import { render, staticRenderFns } from "./rankStat.vue?vue&type=template&id=2ef50278&"
import script from "./rankStat.vue?vue&type=script&lang=js&"
export * from "./rankStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports